import { Injectable, inject, DestroyRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AccessLogService } from './access-log.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {
  private router = inject(Router);
  private accessLogService = inject(AccessLogService);
  private authService = inject(AuthService);
  private destroyRef = inject(DestroyRef);
  private initialized = false;

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((event) => {
      const user = this.authService.user();
      if (!user) {
        return;
      }

      const url = event.urlAfterRedirects || event.url;
      if (url.includes('/sign-in')) {
        return;
      }

      this.accessLogService.addLog({
        userId: user.uid,
        userName: user.email || '',
        action: 'page.access',
        resource: url,
        status: 'success'
      });
    });
  }
}
